import { Component, Host, h, Prop, State, Element } from '@stencil/core';
import { addIntersectionObserver } from '../../utils/utils';


@Component({
  tag: 'conversion-block',
  styleUrl: 'conversion-block.css',
  shadow: false,
})
export class ConversionBlock {
  /**
   * The title
   */
  @Prop() mainTitle: string;
  /**
   * Form Title
   */
  @Prop() formTitle: string;

  /**
   * Contact Text
   */
  @Prop() contactText: string;

  /**
   * The content Type
   */
  @Prop() contentType: string;

  /**
   * The Description
   */
  @Prop() description: string;
  /**
   * Form ID
   */
  @Prop() formId: string;

  /**
   * Icons data
   */
  @Prop() iconsData: string;

  /**
   * Asset Type
   */
  @Prop() assetType: string;

  /**
   * Image URL
   */
  @Prop() imageUrl: string;

  /**
   * Image ALT
   */
  @Prop() imageAlt: string;

  /**
   * Video Url
   */
  @Prop() videoUrl: string;

  /**
   * Caption
   */
  @Prop() caption: string;

  /**
   * Contact data
   */
  @Prop() contactsData: string;

  /**
   * Background Color
   */
  @Prop() backgroundColor: string;

  /**
   * Text Color
   */
  @Prop() textColor: string;

  /**
   * Padding Top
   */
  @Prop() paddingTop: string;

  /**
   * Padding Bottom
   */
  @Prop() paddingBottom: string;

  /**
   * Background Image Url
   */
  @Prop() backgroundImage: string;

  @Element() el: HTMLElement;

  @State() scriptLoaded: boolean = false;

  componentDidLoad() {
    const script = document.createElement('script');
    script.src = '//saferworld.3eco.com/js/forms2/js/forms2.min.js';
    script.onload = () => {
      this.scriptLoaded = true;
      if (window.MktoForms2) {
        window.MktoForms2.loadForm('//saferworld.3eco.com', '026-BZE-703', parseInt(this.formId));
        this.loadHiddenFieldsScript();
      }
    };
    document.body.appendChild(script);

    addIntersectionObserver(
      this.el.querySelector('.cta-form-section'),
      () => {
        this.el.querySelector('.cta-form-section').classList.add('animate');
      },
      ['.overlay1', '.overlay2'],
    );
  }

  loadHiddenFieldsScript() {
    // URL for the hidden fields script, dependent on MktoForms2
    const hiddenFieldsScriptUrl = 'https://saferworld.3eco.com/rs/026-BZE-703/images/mkto-forms.js';
  
    if (this.scriptLoaded && !document.querySelector(`script[src="${hiddenFieldsScriptUrl}"]`)) {
      const script = document.createElement('script');
      script.src = hiddenFieldsScriptUrl;
      document.body.appendChild(script);
    }
  }

  render() {
    const iconRows = JSON.parse(this.iconsData);
    const contactRows = JSON.parse(this.contactsData);
    //console.log(contactRows);
    return (
      <Host>
        <div class={` ${this.textColor} container ${this.paddingBottom}  `} style={{ backgroundImage: `url(${this.backgroundImage})` }}>
          <div class={`conversion-banner-grid-wrapper`}>
            <div class={`grid-col-1 ${iconRows.length > 0 && this.contentType === 'standard' ? '!text-white' : '!text-dark-blue dark-blue-links'} `}>
              <div class={`grid-col-1-bg ${this.backgroundColor} ${iconRows.length > 0 && this.contentType === 'standard' && this.imageUrl && 'h-3/4'}`}>
                <div
                  class={`card-top-overlay ${this.backgroundColor === 'bg-light-blue' ? 'bg-medium-blue' : 'bg-dark-blue'} ${
                    iconRows.length > 0 && this.contentType === 'standard' && 'h-[90%]'
                  }`}
                ></div>
              </div>
              {this.mainTitle && <h1 class={`fs-6 font-semibold ${this.textColor} z-10`}>{this.mainTitle}</h1>}
              {this.description && <div class={`fs-2 font-normal ${this.textColor} z-10`} innerHTML={this.description}></div>}

              <div class={`z-10 flex flex-col gap-64px`}>
                {iconRows.length > 0 && (
                  <div class={`flex flex-wrap gap-y-32px gap-x-16px`}>
                    {iconRows.length > 0 &&
                      iconRows &&
                      iconRows.map(row => (
                        <div class={`conversion-banner-icon-items flex gap-20px w-full items-center`}>
                          <div class="w-64px h-64px aspect-square">
                            {row.imageUrl && <image-block imageUrl={row.imageUrl} imageAlt={row.imageAlt} imageClass="icon-row-image"></image-block>}
                          </div>
                          <p class={` fs-min font-normal mb-0`}>{row.title}</p>
                        </div>
                      ))}
                  </div>
                )}
                <div>
                  {this.caption && <p class={`fs-1 font-normal md:max-w-[350px]`}>{this.caption}</p>}
                  {this.assetType === 'image' && this.imageUrl && <image-block imageUrl={this.imageUrl} imageAlt={this.imageAlt} imageClass={`rounded-xl`}></image-block>}
                  {this.assetType === 'video' && this.videoUrl && <video-block videoUrl={this.videoUrl} videoClass={`rounded-xl overflow-hidden`}></video-block>}
                </div>
                {contactRows.length > 0 && this.contentType === 'contact' && (
                  <div class={`flex flex-col`}>
                    {/* <h4 class={`fs-2 text-dark-blue  ${this.textColor} mb-20px`}>{this.contactText}</h4> */}
                    {contactRows.length > 0 && contactRows.map(row => <div class={`conversion-banner-bottom-rows fs-1 font-normal text-dark-blue ${this.textColor}`} innerHTML={row.contact_info}></div>)}
                  </div>
                )}
              </div>
            </div>
            <div class={`grid-col-2`}>
              <h3 class={`fs-2 text-ui-gray-6 font-semibold mb-20px`}>{this.formTitle}</h3>
              <form id={this.formId} class={`flex flex-col items-center justify-center text-center mx-auto w-full`}>
                {this.scriptLoaded && <form id={`mktoForm_${this.formId}`} class={`cta-form text-white`}></form>}
              </form>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
